// Market type mapping helper function
export const getMarketTypeDetails = (id: number) => {
  const marketTypes = {
    1: {
      id: 1,
      name: "1X2",
      hasLines: false,
      description: "Who will win the game (1X2)",
      betGroup: "1X2",
    },
    52: {
      id: 52,
      name: "Match Winner",
      hasLines: false,
      description: "Who will win the game",
      betGroup: "game-lines",
    },
    88: {
      id: 88,
      name: "To Qualify",
      hasLines: false,
      description: "Which team will qualify",
      betGroup: "game-lines",
    },
    226: {
      id: 226,
      name: "12 Including Overtime",
      hasLines: false,
      description: "Who will win the game including overtime (no draw)",
      betGroup: "game-lines",
    },
    3: {
      id: 3,
      name: "Asian Handicap",
      hasLines: true,
      description: "Who will win the game with handicap (no draw)",
      betGroup: "game-lines",
    },
    201: {
      id: 201,
      name: "Asian Handicap Games",
      hasLines: true,
      description: "Who will win more games with handicap (no draw)",
      betGroup: "game-lines",
    },
    342: {
      id: 342,
      name: "Asian Handicap Including Overtime",
      hasLines: true,
      description:
        "Who will win the game with handicap (no draw) including Overtime",
      betGroup: "game-lines",
    },
    2: {
      id: 2,
      name: "Over/Under",
      hasLines: true,
      description: "Will the score be over/under a specific line",
      betGroup: "game-lines",
    },
    835: {
      id: 835,
      name: "Asian Under/Over",
      hasLines: true,
      description: "Will the score be under/over specific asian line",
      betGroup: "game-lines",
    },
    28: {
      id: 28,
      name: "Under/Over Including Overtime",
      hasLines: true,
      description:
        "Will the score including overtime be over/under a specific line",
      betGroup: "game-lines",
    },
    29: {
      id: 29,
      name: "Under/Over Rounds",
      hasLines: true,
      description:
        "Will the number of rounds in the match will be under/over a specific line",
      betGroup: "game-lines",
    },
    166: {
      id: 166,
      name: "Over/Under Games",
      hasLines: true,
      description: "Number of games will be under/over a specific line",
      betGroup: "game-lines",
    },
    1536: {
      id: 1536,
      name: "Under/Over Maps",
      hasLines: true,
      description: "Will the number of maps be under/over a specific line",
      betGroup: "game-lines",
    },
    274: {
      id: 274,
      name: "Outright Winner",
      hasLines: false,
      description: "Winner of a tournament, not a single match",
      betGroup: "outright-winner",
    },
    202: {
      id: 202,
      name: "First Period Winner",
      hasLines: false,
      description: "Who will win the 1st Period Home/Away",
      betGroup: "first-period-lines",
    },
    203: {
      id: 203,
      name: "Second Period Winner",
      hasLines: false,
      description: "Who will win the 2nd Period Home/Away",
      betGroup: "second-period-lines",
    },
    204: {
      id: 204,
      name: "Third Period Winner",
      hasLines: false,
      description: "Who will win the 3rd Period Home/Away",
      betGroup: "third-period-lines",
    },
    205: {
      id: 205,
      name: "Fourth Period Winner",
      hasLines: false,
      description: "Who will win the 4th Period Home/Away",
      betGroup: "fourth-period-lines",
    },
    866: {
      id: 866,
      name: "Set Handicap",
      hasLines: true,
      description: "Which team/player will win more sets with handicap",
      betGroup: "set-betting",
    },
    165: {
      id: 165,
      name: "Set Total",
      hasLines: true,
      description: "Number of sets will be under/over a specific line",
      betGroup: "set-betting",
    },
    53: {
      id: 53,
      name: "Asian Handicap Halftime",
      hasLines: true,
      description: "Who will win the 1st half with handicap (no draw)",
      betGroup: "first-half-lines",
    },
    64: {
      id: 64,
      name: "Asian Handicap First Period",
      hasLines: true,
      description: "Who will win the 1st period with handicap (no draw)",
      betGroup: "first-period-lines",
    },
    65: {
      id: 65,
      name: "Asian Handicap Second Period",
      hasLines: true,
      description: "Who will win the 2nd period with handicap (no draw)",
      betGroup: "second-period-lines",
    },
    66: {
      id: 66,
      name: "Asian Handicap Third Period",
      hasLines: true,
      description: "Who will win the 3rd period with handicap (no draw)",
      betGroup: "third-period-lines",
    },
    63: {
      id: 63,
      name: "12 Halftime",
      hasLines: false,
      description: "Who will win the 1st half (no draw)",
      betGroup: "first-half-lines",
    },
    77: {
      id: 77,
      name: "Under/Over Halftime",
      hasLines: true,
      description:
        "Will the score in the 1st half be under/over a specific line",
      betGroup: "first-half-lines",
    },
    21: {
      id: 21,
      name: "Under/Over First Period",
      hasLines: true,
      description:
        "Will the score in the 1st period be under/over a specific line",
      betGroup: "first-period-lines",
    },
    45: {
      id: 45,
      name: "Under/Over Second Period",
      hasLines: true,
      description:
        "Will the score in the 2nd period be under/over a specific line",
      betGroup: "second-period-lines",
    },
    46: {
      id: 46,
      name: "Under/Over Third Period",
      hasLines: true,
      description:
        "Will the score in the 3rd period be under/over a specific line",
      betGroup: "third-period-lines",
    },
    281: {
      id: 281,
      name: "1st Five Innings Asian handicap",
      hasLines: true,
      description: "Who will win the 1st five innings with handicap (no draw)",
      betGroup: "first-five-innings",
    },
    1618: {
      id: 1618,
      name: "1st 5 Innings Winner-12",
      hasLines: false,
      description: "Who will win in the 1st five innings",
      betGroup: "first-five-innings",
    },
    236: {
      id: 236,
      name: "1st 5 Innings Under/Over",
      hasLines: true,
      description:
        "Will the score in the 1st five innings be under/over a specific line",
      betGroup: "first-five-innings",
    },
    74192: {
      id: 74192,
      name: "Full Time Result",
      hasLines: false,
      description:
        "You predict the result of a match at the end of regular play. Bets can be placed by either selecting a Team 1 Win, a Draw or a Team 2 Win",
      betGroup: "game-outcome",
    },
    28506: {
      id: 28506,
      name: "Double Chance",
      hasLines: false,
      description:
        "A market that allows you to cover two of the three possible outcomes in a game with one bet. It is similar to full time result betting but effectively you back two outcomes in 1 bet.",
      betGroup: "game-outcome",
    },
  }

  const marketType = marketTypes[id as keyof typeof marketTypes]

  if (marketType) {
    // Transform betGroup: remove hyphens and capitalize each word
    const transformedBetGroup = marketType.betGroup
      .split("-")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ")

    return {
      ...marketType,
      betGroup: transformedBetGroup,
    }
  }

  return {
    id,
    name: "Unknown",
    hasLines: false,
    description: "Unknown market type",
    betGroup: "Unknown",
  }
}

// Type definition for market type details
export interface MarketTypeDetails {
  id: number
  name: string
  hasLines: boolean
  description: string
  betGroup: string
}
